function updateCountdown() {
  const el = document.getElementById("countdown");

  if (!el) return;

  const now = new Date();
  const end = new Date();
  end.setHours(24, 0, 0, 0);

  const diff = end - now;

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  el.textContent =
    String(hours).padStart(2, "0") + ":" +
    String(minutes).padStart(2, "0") + ":" +
    String(seconds).padStart(2, "0");
}

setInterval(updateCountdown, 1000);
setTimeout(updateCountdown, 500);
setTimeout(updateCountdown, 1500);
setTimeout(updateCountdown, 3000);